import PropTypes from "prop-types"
import { TableSortLabel } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { ASC, DESC } from "helpers/sorts"
import { Star } from "@mui/icons-material"

const isDescendingAlpha = ({ alphabetical, direction }) => alphabetical && direction === "desc"
const isAscendingAlpha = ({ alphabetical, direction }) => alphabetical && direction === "asc"
const isDescendingSort = ({ active, absolute, direction }) => active && !absolute && direction === "desc"
const isAscendingSort = ({ active, absolute, direction }) => active && !absolute && direction === "asc"
const isDescendingAbsoluteSort = ({ active, absolute, direction }) => active && absolute && direction === "desc"
const isAscendingAbsoluteSort = ({ active, absolute, direction }) => active && absolute && direction === "asc"

// TODO (#181810872): Make sort labels configurable per table
export default function SortLabelWithTooltip({ alphabetical, absolute, active, direction, noSortLabels, favorite, children, tooltipText, ...props }) {
  const sortProps = { alphabetical, active, absolute, direction }

  const makeTitleFragment = (description) => <>{tooltipText || children}{description && <div>{description}</div>}</>

  const getTitle = () => {
    switch (true) {
      case noSortLabels:
        return children
      case isDescendingAlpha(sortProps):
        return makeTitleFragment("Sorted Z-A")
      case isAscendingAlpha(sortProps):
        return makeTitleFragment("Sorted A-Z")
      case isDescendingSort(sortProps):
        return makeTitleFragment("Sorted positive to negative")
      case isAscendingSort(sortProps):
        return makeTitleFragment("Sorted negative to positive")
      case isDescendingAbsoluteSort(sortProps):
        return makeTitleFragment("Sorted high to low magnitude")
      case isAscendingAbsoluteSort(sortProps):
        return makeTitleFragment("Sorted low to high magnitude")
    }
    return makeTitleFragment()
  }

  return <TableSortLabel
    active={active}
    direction={direction}
    {...props}
  >
    {favorite && <Star className="favorite" />}
    <Tooltip title={getTitle()}>
      <span>{children}</span>
    </Tooltip>
  </TableSortLabel>
}

SortLabelWithTooltip.propTypes = {
  active: PropTypes.bool,
  alphabetical: PropTypes.bool,
  absolute: PropTypes.bool,
  direction: PropTypes.oneOf([ASC, DESC]),
  noSortLabels: PropTypes.bool,
  favorite: PropTypes.bool,
  tooltipText: PropTypes.string,
}
